export * from './user-notification-dialog-header';

import { UserNotificationDialogHeaderComponent } from "./user-notification-dialog-header";

export const UserNotificationDialogAtoms = [UserNotificationDialogHeaderComponent];